import React, { useState } from 'react';

import Navbar from '../Navbar/Navbar';
import Footer from '../Footer/Footer';

import { Link } from 'react-router-dom';
import Slider, { Range } from 'rc-slider';
import { TextField } from '@material-ui/core';
import 'rc-slider/assets/index.css';
import './Creport.css';

const Creport = (props) => {
	const { bearerToken } = props;

	return (
		<div>
			<Navbar bearerToken={bearerToken} />
			<div className='container'>
				<div className="heading">
					<div className="row">
						<div className="col s12">
							<h4>Child Report </h4>
						</div>
					</div>
				</div>

				<div className="row">
					<div className="col m6 s12">
						<div className="card-bg">
							<div className="report-card">
								<h5>Child Growth Analysis Report</h5>
								<p>Medical reports include the findings of the clinical examination conducted.</p>
								<div className="report-btns">
									<a href="">View</a> <a href="">Download</a>
									<a href="">Share</a></div>
							</div>
							<div className="report-img"></div>
						</div>
					</div>

					<div className="col m6 s12">
						<div className="card-bg">
							<div className="report-card">
								<h5>Child Development Analysis Report</h5>
								<p>Medical reports include the findings of the clinical examination conducted.</p>
								<div className="report-btns">
									<a href="">View</a> <a href="">Download</a>
									<a href="">Share</a></div>
							</div>
							<div className="report-img"></div>
						</div>
					</div>

				</div>
				<div className="row">
					<div className="col m6 s12">
						<div className="card-bg">
							<div className="report-card">
								<h5>Child Growth Analysis Report</h5>
								<p>Medical reports include the findings of the clinical examination conducted.</p>
								<div className="report-btns">
									<a href="">View</a> <a href="">Download</a>
									<a href="">Share</a></div>
							</div>
							<div className="report-img"></div>
						</div>
					</div>

					<div className="col m6 s12">
						<div className="card-bg">
							<div className="report-card">
								<h5>Child Development Analysis Report</h5>
								<p>Medical reports include the findings of the clinical examination conducted.</p>
								<div className="report-btns">
									<a href="">View</a> <a href="">Download</a>
									<a href="">Share</a></div>
							</div>
							<div className="report-img"></div>
						</div>
					</div>

				</div>


			</div>



			<Footer />
		</div>
	);
};


export default Creport;
